import React from 'react';

export const Crown = ({ className }: { className?: string }) => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1.55228 11.23L0.0364736 5.36915C-0.201026 4.49665 0.770657 3.79668 1.52232 4.29834L3.45231 5.58499C3.86647 5.86166 4.42979 5.70417 4.64229 5.25334L6.6123 1.06249C6.96397 0.313322 8.02982 0.313341 8.38232 1.06167L10.3573 5.25415C10.5698 5.70499 11.1323 5.86082 11.5465 5.58499L13.4765 4.29834C14.229 3.79668 15.2006 4.49749 14.9623 5.36915L13.4465 11.23C13.304 11.7817 12.8065 12.1667 12.2365 12.1667H2.76149C2.19232 12.1667 1.69478 11.7817 1.55228 11.23ZM13.5415 14.6667C13.5415 14.3217 13.2615 14.0417 12.9165 14.0417H2.08313C1.73813 14.0417 1.45814 14.3217 1.45814 14.6667C1.45814 15.0117 1.73813 15.2917 2.08313 15.2917H12.9165C13.2615 15.2917 13.5415 15.0117 13.5415 14.6667Z"
      fill="#FBBC05"
    />
  </svg>
);
